// actions/webSocketActions.js
export const webSocketActions = {
  CONNECT: 'websocket/CONNECT',
  DISCONNECT: 'websocket/DISCONNECT',
  RECEIVE_MESSAGE: 'websocket/RECEIVE_MESSAGE',
  WEBSOCKET_ERROR: 'websocket/WEBSOCKET_ERROR'
};
